import ZooxPay from "zoox-pay";
import PersonService from "./person-service";
import { ApiClient, CryptoLocalStorage } from "zoox-infra";

export default class OrderService {
  constructor() {
    const personService = new PersonService();
    const personId = personService.getPersonId();
    const accessToken = personService.getPersonToken();
    this.zooxPay = new ZooxPay({
      accessToken,
      personId,
      baseUrl: process.env.VUE_APP_ZOOXPAY_BASE_URI
    });
    this.apiClient = new ApiClient();
  }

  async getOrder(params) {
    const response = await this.zooxPay.listOrders(params);
    return response.result[0];
  }

  async getOrderItems({ orderId }) {
    const response = await this.zooxPay.listOrderItems({ orderId });
    return response.result;
  }

  async getBulkItems(ids) {
    return this.apiClient.post(`payment/order/itemsBulk`, { ids });
  }

  async getAllOrders(personId) {
    const response = await this.apiClient.get(`payment/order/all/${personId}`);
    return response.result;
  }

  async getBillingHistory(companyId, personId) {
    return this.apiClient.post(`payment/order/statement`, {
      companyId,
      personId
    });
  }

  async getChargeByToken(token) {
    return this.apiClient.get(`payment/chargeByToken/${token}`);
  }

  async getOrderById(id) {
    return this.apiClient.get(`payment/orderById/${id}`);
  }

  setLocalOrder(order = null) {
    CryptoLocalStorage.setItem("order", JSON.stringify(order));
  }

  getLocalOrder() {
    const orderStr = CryptoLocalStorage.getItem("order") || null;
    try {
      return JSON.parse(orderStr);
    } catch (ex) {
      return null;
    }
  }
}
